import BasicLightbox from '../BasicLightbox'
import messageResource from '../messageResource'
import $ from 'jquery'
import UserProfileSection from './UserProfileSection'
import {isEsc, KEY_HANDLERS} from '../keyHandlers/index'
import makeRpcCall from '../util/jquery_rpc'
import {PasswordValidators} from '../util/passwords/PasswordSettings'
import {ValidationErrors} from '../panels/user/constants'

function UserProfilePopup() {
}

UserProfilePopup.JQUERY_RPC_TIMEOUT = 120000; // 2 minutes

UserProfilePopup.prototype = new BasicLightbox();

UserProfilePopup.prototype.cancel_confirmation_message_key = "profile.js.cancel_confirmation";
UserProfilePopup.prototype.close_tab_confirmation_message_key = "profile.js.close_tab_confirmation";
UserProfilePopup.prototype.exist_invalid_fields_message_key = "profile.js.footer_error.exist_invalid_fields";
UserProfilePopup.prototype.invalid_fields_sent_to_server_message_key = "profile.js.footer_error.invalid_fields_sent_to_server";
UserProfilePopup.prototype.incorrect_password_message_key = "profile.js.footer_error.incorrect_password";
UserProfilePopup.prototype.no_such_user_message_key = "profile.js.error.user_deleted";
UserProfilePopup.prototype.user_is_locked_message_key = "profile.js.error.user_is_locked";

UserProfilePopup.prototype.init = function(data, isLocked, successCallback, isPTOEnabled, isSickEnabled) {
    this._popupId = "userProfilePopup";
    this._popupEl = $("#userProfilePopup");

    BasicLightbox.prototype.init.call(this, this._popupId, "closeUserProfilePopupButton");

    var self = this;

    this._locked = isLocked;
    if (isLocked) {
        this._commitEnabled = false;
        $(this.commitButton).attr("title", messageResource.getMessage("profile.js.user_is_locked"));
    }

    this.dataChanged = false;
    this._changesCallback = function() {
        if (!self.dataChanged)
            self.changesDetected();
        self.dataChanged = true;
    };

    this._isPTOEnabled = isPTOEnabled;
    this._isSickEnabled = isSickEnabled;

    data.currentTime = data.currentTimeInUserTimeZone;
    this._userProfileSection = this.createUserProfileSection(data);

    this.validate();

    this.setCancelCallback(function() { self.hide(); });

    this.setSuccessCallback(
        function(profileInfo) {
            self._makeUpdateProfileRequest(profileInfo, successCallback);
        }
    );

    if (navigator.userAgent.toLowerCase().indexOf("msie 8") > -1) {
        this._popupEl.addClass("ie8");
    }

    this.updateUI();

    return this;
};

UserProfilePopup.prototype.createUserProfileSection = function(data) {
    return new UserProfileSection().init(this._popupEl[0], data, this._changesCallback, this._validateCallback, true, this._isPTOEnabled, this._isSickEnabled,
        true);
};

UserProfilePopup.prototype.changesDetected = function() {
    if (this._locked)
        return;
    this.getFooterEl().className = this.footerClassName + ' changesDetected';
};

UserProfilePopup.prototype.validate = function() {
    return this._userProfileSection.validate();
};

UserProfilePopup.prototype.updateUI = function() {
    this._userProfileSection.updateUI();
    if (this._locked)
        $(this.commitButton).addClass("disabled");
};

UserProfilePopup.prototype.hasErrors = function() {
    return this._userProfileSection.hasErrors();
};

UserProfilePopup.prototype._makeUpdateProfileRequest = function(profileInfo, successCallback) {
    this.disableUserInputWhileSaving();
    var self = this;
    var successHandler = function() {
        self.enableUserInputWhileSaving();
        if (successCallback) {
            successCallback();
        }
        $(document).trigger('close_user_profile_event')
        self.hide();
    };

    var failCallback = function(jqXHR, textStatus, errorThrown) {

        if (!errorThrown || !errorThrown.exception) {
            self.hide();
            return false;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.services.UserEmailInvalidException') != -1) {
            self._userProfileSection.setEmailInvalid();
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.UserExistsException') != -1) {
            self._userProfileSection.setUsernameDuplicateError();
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.administration.passwords.service.PasswordPolicyViolatedException') !== -1) {
            self._userProfileSection.setPasswordError(ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, errorThrown[PasswordValidators.PASSWORD_VALIDATION_RESULT_JSON]);
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.services.EditProfileService$IncorrectPasswordException') != -1) {
            self._userProfileSection.setOldPasswordIncorrectError()
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.NoSuchUserException') != -1) {
            alert(messageResource.getMessage(self.no_such_user_message_key));
            self.hide();
            document.location.reload();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.UserIsLockedException') != -1) {
            alert(messageResource.getMessage(self.user_is_locked_message_key));
            self.enableUserInputWhileSaving();
            self.hide();
            return true;
        }

        if (errorThrown.exception.indexOf('java.lang.IllegalArgumentException') != -1) {
            alert(messageResource.getMessage(self.invalid_fields_sent_to_server_message_key));
            self.enableUserInputWhileSaving();
            return true;
        }

        self.hide();
        return false;
    };

    makeRpcCall(this.getServiceAndMethod(), [profileInfo],
        successHandler, failCallback);
};

UserProfilePopup.prototype.restoreOnKeyDownHandler = function() {
    if (this.unregKeyDown) this.unregKeyDown()
}

UserProfilePopup.prototype.setupKeyDownHandler = function() {
    this.unregKeyDown = KEY_HANDLERS.onKeyDown((code) => {
        if (isEsc(code)) {
            this.cancel()
            return true
        }
    })
}

UserProfilePopup.prototype.getServiceAndMethod = function() { };

export default UserProfilePopup



// WEBPACK FOOTER //
// ./web/js/userProfile/UserProfilePopup.js